import axios from 'axios'
import config from '@/config'
import store from 'store2'
import { ElMessage } from 'element-plus'
import { stringify } from 'qs' // parse stringify
// import { getToken, removeToken } from '@/utils/auth'
// const CancelToken = axios.CancelToken;

const { apiUrl } = config

// // 请求拦截器
// axios.interceptors.request.use(
//   config => {
//     if (getToken()) {
//       config.headers.Authorization = `Bearer ${getToken()}`
//     }
//     return config
//   },
//   error => {
//     console.log('error', JSON.parse(JSON.stringify(error)))
//     return Promise.reject(error)
//   }
// )

// 响应拦截器即异常处理
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // console.log('error', error)
    // if (error.response.data.message === 'No message available') {
    //   removeToken()
    // }
    // if (error.response.status === 401) {
    //   setTimeout(() => {
    //     removeToken()
    //   }, 1500)
    // }
    return Promise.resolve(error.response)
  }
)

// 设置默认请求头
axios.defaults.headers = {
  'X-Requested-With': 'XMLHttpRequest',
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
  'Access-Control-Allow-Headers': 'x-requested-with,content-type'
}
axios.defaults.timeout = 1000000

export default {
  getToken () {
    let token
    if (sessionStorage.getItem('aillo-article-token')) {
      token = sessionStorage.getItem('aillo-article-token')
    } else if (store.get('aillo-article-token')) {
      token = store.get('aillo-article-token')
    } else {
      token = null
    }
    return token
  },
  // get
  get (url, param) {
    return new Promise((resolve, reject) => {
      const data = {
        method: 'get',
        url: `${apiUrl}${url}`
      }
      if (param) {
        data.params = param
      }
      axios(data).then(res => {
        if (res.data.status !== 'success') {
          reject(res.data.messages)
          ElMessage.error(res.data.messages[0])
          if (url === '/management/login/getUserInfo') {
            location.reload(true)
          }
        }
        resolve(res.data.result || res.data)
      })
    })
  },
  postQuery (url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `${apiUrl}${url}?${stringify(param)}`
        // cancelToken: new CancelToken(c => {
        //   // cancel = c
        // })
      }).then(res => {
        if (!res.data.status === 'success') {
          reject(res)
        }
        resolve(res.data.result)
      })
    })
  },
  bolbPost (url, param, options) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `${apiUrl}${url}`,
        data: param,
        ...options
        // cancelToken: new CancelToken(c => {
        //   // cancel = c
        // })
      }).then(res => {
        resolve(res.data)
      })
    })
  },
  // post
  post (url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `${apiUrl}${url}`,
        data: param
        // cancelToken: new CancelToken(c => {
        //   // cancel = c
        // })
      }).then(res => {
        if (res.data.status !== 'success') {
          ElMessage.error(res.data.messages[0])
          reject(res.data.messages)
        }
        resolve(res.data.result || res.data)
      })
    })
  },
  formPost (url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `${apiUrl}${url}`,
        data: param,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Headers': 'x-requested-with,content-type'
        }
      }).then(res => {
        console.log('res', res)
        if (!res.data.status === 'success') {
          // Message.error(res.data.message);
          reject(res.data.messages)
        }
        resolve(res.data.result)
      })
    })
  },
  // put
  put (url, param) {
    console.log('param', param)
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: `${apiUrl}${url}`,
        data: param
        // cancelToken: new CancelToken(c => {
        //   // cancel = c
        // })
      }).then(res => {
        if (!res.data.status === 'success') {
          // Message.error(res.data.message);
          reject(res)
        }
        resolve(res.data.result)
      })
    })
  },
  // delete
  delete (url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `${apiUrl}${url}`,
        data: param
      }).then(res => {
        if (!res.data.status === 'success') {
          reject(res)
        }
        resolve(res.data.result)
      })
    })
  },
  // 兼容请求返回信息
  // post
  postWith (url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `${apiUrl}${url}`,
        data: param
        // cancelToken: new CancelToken(c => {
        //   // cancel = c
        // })
      }).then(res => {
        if (!res.data.status === 'success') {
          reject(res)
        }
        resolve(res.data)
      })
    })
  }
}
